import { format, isThisYear, isToday, isYesterday, differenceInMinutes, formatDistanceToNowStrict } from 'date-fns';

export function listTime(iso: string): string {
  const d = new Date(iso);
  if (isToday(d)) {
    const mins = differenceInMinutes(new Date(), d);
    if (mins < 1) return 'now';
    if (mins < 60) return `${mins}m`;
    return format(d, 'h:mm a');
  }
  if (isYesterday(d)) return 'Yesterday';
  if (differenceInMinutes(new Date(), d) < 6 * 24 * 60) return format(d, 'EEE');
  return isThisYear(d) ? format(d, 'MMM d') : format(d, 'MMM d, yyyy');
}

export function fullTime(iso: string): string {
  return format(new Date(iso), "EEE, MMM d, yyyy 'at' h:mm a");
}

export function ago(iso: string): string {
  return formatDistanceToNowStrict(new Date(iso), { addSuffix: true });
}

export function greeting(): string {
  const h = new Date().getHours();
  if (h < 5) return 'Burning the midnight oil';
  if (h < 12) return 'Good morning';
  if (h < 17) return 'Good afternoon';
  return 'Good evening';
}

/** Colours are tokens (styles.css): bright in dark mode, printed inks in the light Dossier. */
export const CATEGORY_META: Record<string, { label: string; color: string }> = {
  needs_reply: { label: 'Needs reply', color: 'var(--cat-needs-reply)' },
  important: { label: 'Important', color: 'var(--cat-important)' },
  fyi: { label: 'FYI', color: 'var(--cat-fyi)' },
  newsletter: { label: 'Newsletter', color: 'var(--cat-newsletter)' },
  promotion: { label: 'Promo', color: 'var(--cat-promotion)' },
  notification: { label: 'Alert', color: 'var(--cat-notification)' },
  receipt: { label: 'Receipt', color: 'var(--cat-receipt)' },
};

export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(String(r.result).split(',')[1] ?? '');
    r.onerror = () => reject(r.error);
    r.readAsDataURL(file);
  });
}
